import type { SupabaseClient } from '@supabase/supabase-js';
import { SUPABASE_ANON_KEY, SUPABASE_URL } from '../config';

export type Database = {
  public: {
    Tables: {
      saved_artists: {
        Row: { user_id: string; spotify_artist_id: string; name: string; image_url: string | null; created_at: string };
        Insert: { user_id: string; spotify_artist_id: string; name: string; image_url?: string | null; created_at?: string };
        Update: { name?: string; image_url?: string | null };
        Relationships: [];
      };
    };
    Views: Record<string, never>;
    Functions: { delete_my_account: { Args: Record<string, never>; Returns: undefined } };
    Enums: Record<string, never>;
    CompositeTypes: Record<string, never>;
  };
};

export type Supabase = SupabaseClient<Database>;

export const SUPABASE_ENABLED = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

let client: Promise<Supabase> | null = null;

/**
 * supabase-js is ~45 KB gzipped, so it loads as its own chunk, in parallel with first render,
 * and only when Supabase is configured.
 */
export function getSupabase(): Promise<Supabase> {
  if (!SUPABASE_ENABLED) throw new Error('Supabase is not configured');
  client ??= import('@supabase/supabase-js').then(({ createClient }) =>
    createClient<Database>(SUPABASE_URL!, SUPABASE_ANON_KEY!, {
      auth: { flowType: 'pkce', detectSessionInUrl: true, persistSession: true, autoRefreshToken: true },
    }),
  );
  return client;
}
